import { SplashScreen } from '@capacitor/splash-screen';
import { Injectable } from '@angular/core';
import { PlatformService } from './platform.service';
import { ExternalSettingsService } from 'src/app/common/services/external-settings/external-settings.service';
import { combineLatest } from 'rxjs';
import { MEErrorService } from 'src/app/common/error/me-error.service';

@Injectable({
    providedIn: 'root'
})
export class SplashScreenService {

    constructor(
        private srvES: ExternalSettingsService,
        private srvError: MEErrorService,
    ) { }

    public init() {
        if (!PlatformService.isMobile()) return;

        // Hide the splash screen when the external settings are loaded
        combineLatest([this.srvES.externalSettings$]).subscribe(() => {
            SplashScreen.hide();
        });

        // Hide the splash screen when the system is unavailable
        combineLatest([this.srvError.systemUnAvailableError]).subscribe(() => {
            SplashScreen.hide();
        });

    }
}